import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { PaymentMethodDestroyInput, PaymentMethodDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = PaymentMethodDestroyInput;
type TData = PaymentMethodDestroyPayload;

export const useCreditCardDelete = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation paymentMethodDestroy($input: PaymentMethodDestroyInput!) {
      paymentMethodDestroy(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
